import React from 'react';
import { useParams } from 'react-router-dom';
import { gql, useQuery } from '@apollo/client';
import { PageContainer } from '@ant-design/pro-layout';
import ProjectHeader from '../ProjectHeader';
import {
  CORE_PROJECT_TYPE_FIELDS,
  CORE_FACULTY_FIELDS,
  CORE_PROJECT_CATEGORY_FIELDS,
} from '../../../gql/fragments';
import EditProfileForm from './components/EditProfileForm';
import './editProfile.less';

const GET_PROJECT_PROFILE = gql`
  ${CORE_PROJECT_TYPE_FIELDS}
  ${CORE_FACULTY_FIELDS}
  ${CORE_PROJECT_CATEGORY_FIELDS}
  query GET_PROJECT_PROFILE($ids: [ID!], $status: Status) {
    projects(ids: $ids, status: $status) {
      nodes {
        id
        title
        projectCategory {
          id
          name
        }
        projectStatus {
          id
          name
        }
        profile {
          researchRelated
          projectType {
            id
            name
          }
          projectCode
          department {
            id
            name
            faculty {
              id
              name
            }
          }
          accountCode
          accountSetUpDate
          accountClosedDate
          workProgramme
          originalStartDate
          originalCompletionDate
          actualStartDate
          actualCompletionDate
          deadlineOfUsingUpFunding
          lastApprovedCompletionDate
          approvedFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          additionalFunding {
            amount
            source {
              id
              name
            }
            conditionOfAllocation
          }
          proposal {
            id
            filename
          }
          supplements {
            id
            filename
          }
          historyLog
          historyLogByPMS
        }
      }
    }
    projectCategories {
      ...CoreProjectCategoryFields
    }
    faculties {
      ...CoreFacultyFields
    }
    projectTypes {
      ...CoreProjectTypeFields
    }
  }
`;

const EditProfile = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_PROJECT_PROFILE, {
    variables: { ids: [projectId], status: 'ALL' },
  });
  return (
    <ProjectHeader>
      <PageContainer
        header={{
          title: 'Edit Profile',
        }}
        loading={loading}
      >
        {!loading && <EditProfileForm data={data} />}
      </PageContainer>
    </ProjectHeader>
  );
};

export default EditProfile;
